"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveDialog = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _constants = require("./constants");
var _internal = require("./internal");
var _styles = require("./internal/components/styles");
var _responsiveDialogClasses = require("./responsiveDialogClasses");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * @deprecated Use `Dialog` from `@ori-ui/components` with drawer prop instead.
 * This component will be removed in the future.
 **/
const ResponsiveDialog = ({
  open = false,
  onClose,
  mode = 'auto',
  drawerProps,
  header,
  hideCloseButton,
  footer,
  children,
  className,
  isLoading,
  zIndex,
  closeButtonAriaLabel = 'close',
  ...props
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const isDrawer = mode === 'drawer' || mode === 'auto' && !isMobile;
  const hasFooter = footer !== undefined;
  const shouldRenderFooter = hasFooter && !isLoading;
  const dialogRootClassName = (0, _clsx.default)(_responsiveDialogClasses.responsiveDialogClasses.dialog, className);
  const dialogFooterClassName = (0, _clsx.default)(_responsiveDialogClasses.responsiveDialogClasses.footer, _responsiveDialogClasses.responsiveDialogClasses.dialogFooter);
  const dialogContentClassName = (0, _clsx.default)(_responsiveDialogClasses.responsiveDialogClasses.content, _responsiveDialogClasses.responsiveDialogClasses.dialogContent);
  const content = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_internal.Loading, {}),
    children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_internal.Loading, {}) : children
  }), [children, isLoading]);
  if (isDrawer) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_internal.ResponsiveDialogDrawer, {
      ...drawerProps,
      closeButtonAriaLabel: closeButtonAriaLabel,
      zIndex: zIndex,
      open: open,
      isLoading: isLoading,
      footer: shouldRenderFooter ? footer : undefined,
      hideCloseButton: hideCloseButton,
      header: header,
      className: className,
      onClose: onClose,
      children: content
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.Dialog, {
    ...props,
    closeButtonAriaLabel: closeButtonAriaLabel,
    "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DIALOG),
    open: open,
    className: dialogRootClassName,
    hideCloseButton: hideCloseButton,
    hasFooter: hasFooter,
    header: header,
    zIndex: zIndex,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Content, {
        "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DIALOG_CONTENT),
        className: dialogContentClassName,
        isLoading: isLoading,
        children: content
      }), shouldRenderFooter ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FooterContainer, {
        "data-testid": getTestId(_constants.RESPONSIVE_DIALOG_DIALOG_FOOTER),
        className: dialogFooterClassName,
        children: footer
      }) : null]
    })
  });
};
exports.ResponsiveDialog = ResponsiveDialog;
//# sourceMappingURL=ResponsiveDialog.js.map